/**
 * Check if a value already exists at an index of an array
 *
 * @template T
 * @param {T} value The value to search for
 * @param {number} index index we expect the duplicate to be at
 * @param {T[]} self The array containing the value we are searching for
 * @returns {boolean} True if the value exists at the provided index
 */
export var uniqueArrayFilter = function (value, index, self) { return self.indexOf(value) === index; };
//# sourceMappingURL=uniqueFilter.js.map